import { DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPnnZoneReply extends Layout {
    dataheaderZoneReplyEdit: DataHeader;
    sourcePnnZoneReply: DataSource;
    tabTabGeneral: Tab;
    tabsetGeneral: Tabset;
    textboxDispatchZone: Textbox;
    textboxReplyTo: Textbox;
}
